<template>
	<div class="task-calendar-item-container">
		<div class="task-calendar-item-row px-3 mt-2">
			<div class="task-calendar-item-name">
				<span class="mr-2">{{ item.units }}</span>
				<span>{{ item.kind.display_name }}</span>
			</div>
			<CalendarItemMenu
				@click.stop
				:type="event_item"
				:color="'#0012B1'"
				:privileges="privileges"
				@click-menu-item="$emit('click-menu-item', $event)"
				@delete="$emit('delete')"/>
		</div>
		<div class="task-calendar-item-row px-3">
			<div class="task-calendar-item-column">
				<div>
					<span class="task-calendar-item-text task-calendar-item-color-sub task-calendar-item-main">{{ item.job.code }}</span>&nbsp;&nbsp;
					<span class="task-calendar-item-text task-calendar-item-color-sub  task-calendar-item-sub">{{ item.job.display_name }}</span>
				</div>
				<div v-if="item.phase && item.phase.display_name.length !== 0">
					<span class="task-calendar-item-text task-calendar-item-color-sub task-calendar-item-main">Phase:</span>&nbsp;&nbsp;
					<span class="task-calendar-item-text task-calendar-item-color-sub  task-calendar-item-sub">{{ item.phase.display_name }}</span>
				</div>
			</div>
		</div>
		<div v-if="task_for.length > 0" class="task-calendar-item-row px-3 py-2" style="justify-content: flex-start">
			<div v-for="task_for_item in task_for" :key="task_for_item.id" class="avatar-hover">
				<v-tooltip top color="#FFFFFF">
					<template v-slot:activator="{ on, attrs }">
						<div v-bind="attrs" v-on="on">
							<v-user-avatar
								style="font-size: 0.75rem"
								size="24"
								class="mr-1"
								:code="task_for_item.name"
								:image="`/api/addressbook/${task_for_item.id }/image.png`"
							/>
						</div>
					</template>
					<span class="task-calendar-item-text task-calendar-item-main task-calendar-item-color-main ">{{ task_for_item.name }}</span>
				</v-tooltip>
			</div>
			<div>{{ item.notes }}</div>
		</div>
	</div> 
</template>
<script>
import CalendarItemMenu from "@/views/timesheets/calendar_item_menu.vue";

const Event_Item = 'item';

export default {
	name: 'CalendarItemsItem',
	props: {
		item: {
			type: Object,
			default: () => {}
		},
		privileges: {
			type: Array,
			default: () => []
		},
	},
	components: {
		CalendarItemMenu
	},
	data() {
		this.event_item = Event_Item;
		return {
			note: 'fff'
		}
	},
	computed: {
		task_for() {
			let assigned_tmp = [];

			if (this.item && this.item.address_book) {
				const task_for_tmp = this.item.address_book;
				const name = this.formatName(task_for_tmp.display_name);
				const obj = {
					id: task_for_tmp.id,
					name: name
				};

				assigned_tmp.push(obj);
			}

			return assigned_tmp;
		}
	},
	methods: {
		formatName(name) {
			let display_name = '';
			if (name.includes(',')) {
				const name_arr = name.split(',');
				if (name_arr[1].includes('(')) {
					const name_tmp = name_arr[1];
					const index = name_tmp.indexOf('(');
					const first_name = name_tmp.substring(0, index-1).trim();
					const last_name = name_arr[0].trim();
					display_name = `${first_name} ${last_name} ${name_tmp.substring(index, name_tmp.length)}`;
				} else {
					const first_name = name_arr[1].trim();
					const last_name = name_arr[0].trim();
					display_name = `${first_name} ${last_name}`;
				}
			} else {
				display_name = name;
			}

			return display_name;
		},
	}
}
</script>
<style lang="scss" scoped>
.task-calendar-item-container {
  width: 100%;
	height: 100%;
  background: #F2F3FB;
  border: 1px solid rgba(0, 18, 177, 1);
  box-shadow: 0px 2px 4px rgba(25, 42, 62, 0.12);
  border-radius: 4px;
  z-index: 100;
}
.task-calendar-item-row {
  display: flex;
  flex-flow: row nowrap;
  justify-content: space-between;
  align-items: center;
}
.task-calendar-icons {
	display: flex;
  flex-flow: row nowrap;
  justify-content: flex-end;
  align-items: center;
}
.task-calendar-item-column {
  display: flex;
  flex-flow: column nowrap;
  justify-content: center;
  align-items: flex-start;
}
.task-calendar-item-name {
  font-family: 'Roboto';
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
  letter-spacing: 0.25px;
  color: #0012B1;
}
.task-calendar-item-text {
  font-family: 'Roboto';
  font-style: normal;
  font-size: 12px;
  line-height: 20px;
  letter-spacing: 0.4px;
}
.task-calendar-item-main {
  font-weight: 500;
}
.task-calendar-item-sub {
  font-weight: 400;
}
.task-calendar-item-color-main {
  color: #192A3E;
}
.task-calendar-item-color-sub {
  color: rgba(25, 42, 62, 0.5);
}
.task-calendar-item-color-red {
	color: #192A3E;
	font-weight: 500;
}
.avatar-hover {
	&:hover {
		cursor: pointer;
	}
}
.v-tooltip__content{
	border: 1px solid #192A3E !important;
	opacity: 1 !important;
}
::v-deep {
	.v-badge__badge {
		min-width: 14px;
		height: 14px;
	}
}
</style>
